















































































































































































































































































































































































































import { SfTabs, SfBreadcrumbs } from '@storefront-ui/vue';
import { defineComponent, ref, onMounted, useContext } from '@nuxtjs/composition-api';
import useCustForm from '~/modules/czar/formquery/customForm';
import { Breadcrumb } from '~/modules/catalog/types';
import { useUiState } from '~/composables/useUiState';
import { getMetaInfo } from '~/helpers/getMetaInfo';

export default defineComponent({
    name: 'GovernmentandEDU',
    components: {
        SfTabs,
        SfBreadcrumbs
    },
    setup() {
        const { useCustFormData, loading } = useCustForm();
        const { localePath, app: { i18n } } = useContext();
        const { isHelpModelOpen, toggleHelpModal, isOpenHelpPopup, openHelpPopup } = useUiState();
        const openpopup = ref(false);
        const fullname = ref('');
        const email = ref('');
        const telephone = ref('');
        const brand_1 = ref('');
        const product_1 = ref('');
        const condition_1 = ref('');
        const brand_2 = ref('');
        const product_2 = ref('');
        const condition_2 = ref('');
        const brand_3 = ref('');
        const product_3 = ref('');
        const condition_3 = ref('');
        const brand_4 = ref('');
        const product_4 = ref('');
        const condition_4 = ref('');
        const description = ref('');
        const base64_encoded_file = ref(<any>'');
        const name = ref('');
        var queryVariables = {};
        const previewFiles = (event: InputEvent) => {
            const target = event.target as HTMLInputElement;
            const file: File = (target.files as FileList)[0];
            name.value = file.name;
            const size = file.size;
            if (size < 50000) {
                toBase64(file).then(data => base64_encoded_file.value = data);
            } else {
                name.value = null;
                base64_encoded_file.value = null;
                alert("To large file for upload, please upload small file");
            }
        };
        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.toString().split(',')[1]; // Extracting base64 string
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
        const equipment = async () => {
            const items = [
                {
                    brand: brand_1.value,
                    product: product_1.value,
                    condition: condition_1.value
                },
                {
                    brand: brand_2.value,
                    product: product_2.value,
                    condition: condition_2.value
                },
                {
                    brand: brand_3.value,
                    product: product_3.value,
                    condition: condition_3.value
                },
                {
                    brand: brand_4.value,
                    product: product_4.value,
                    condition: condition_4.value,
                }
            ];
            if (fullname.value && email.value && telephone.value && brand_1.value && product_1.value && condition_1.value && brand_2.value && product_2.value && condition_2.value && brand_3.value && product_3.value && condition_3.value && brand_4.value && product_4.value && condition_4.value) {
                if (name.value && base64_encoded_file.value) {
                    queryVariables = {
                        form_type: 'used_equipment_quote',
                        fullname: fullname.value,
                        email: email.value,
                        files: [{
                            name: name.value,
                            base64_encoded_file: base64_encoded_file.value
                        }],
                        telephone: telephone.value,
                        description: description.value,
                        items: items
                    }
                } else {
                    queryVariables = {
                        form_type: 'used_equipment_quote',
                        fullname: fullname.value,
                        email: email.value,
                        telephone: telephone.value,
                        description: description.value,
                        items: items
                    }
                }
                const resultcust = await useCustFormData(queryVariables);
                if(!loading){
                    alert("Thank you for writing to us. We will get back to you within 3 business days about your inquiry. Thanks again.");
                } 
            } else if (!fullname.value) {
                alert('Please enter your Name.');
            } else if (!email.value) {
                alert('Please enter your Email.');
            } else if (!telephone.value) {
                alert('Please enter your Phone.');
            } else if (!telephone.value) {
                alert('Please enter your Phone.');
            } else if (!brand_1.value && !product_1.value && !condition_1.value && !brand_2.value && !product_2.value && !condition_2.value && !brand_3.value && !product_3.value && !condition_3.value && !brand_4.value && !product_4.value && !condition_4.value) {
                alert('Please enter all brand and product name and select rate for brand and product.');
            } else {
                alert('Please select all fields');
            }
        };
        if(isHelpModelOpen.value == true){
            toggleHelpModal();
        }

        if(isOpenHelpPopup.value == true){
            openHelpPopup();
        }

        onMounted(() => {
            openpopup.value = true;
        });

        const closepopup = () => {
            openpopup.value = false;
        };

        const removeFile = () => {
            name.value = null;
            base64_encoded_file.value = null;
        };

        const breadcrumbs = ref<Breadcrumb[]>([
        {
            text: i18n.t('Home') as string,
            link: localePath('/'),
        },
        {
            text: i18n.t('Used Equipment Quote') as string,
            link: localePath('/used-equipment-quote'),
        },
        ]);

        const pageMeta = {
            "meta_title": null,
            "meta_description": null,
            "meta_keywords": null,
            "name": "Midwest Photo Used Equipment Quote",
        };

        return {
            equipment,
            fullname,
            email,
            telephone,
            description,
            previewFiles,
            base64_encoded_file,
            queryVariables,
            brand_1,
            product_1,
            condition_1,
            brand_2,
            product_2,
            condition_2,
            brand_3,
            product_3,
            condition_3,
            brand_4,
            product_4,
            condition_4,
            closepopup,
            openpopup,
            name,
            removeFile,
            breadcrumbs,
            pageMeta
        };
    },
    head() {
        return getMetaInfo(this.pageMeta);
    },
});
